export const fileTypeParamsMap = {
  pdf: 'pdf',
  xml: 'xmlCfdi',
  zip: 'zip',
}
